// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * Copy of the user-related slice of `utils/constants.ts`, kept in `shared/`
 * so admin-center never imports `utils/` directly (ADR-0014) and this
 * survives the Module Federation split without a rewrite. Only the pieces
 * admin-center actually calls — not the full endpoint catalogue.
 */

export const ENDPOINTS = {
  USERS: '/api/v1/users',
  USERS_INVITE: '/api/v1/users/invite',
  USERS_FEDERATED_INVITE: '/api/v1/users/federated/invite',
  USERS_FEDERATED_DOMAINS: '/api/v1/users/federated/domains',
  USER_BY_ID: (userId: string) => `/api/v1/users/${userId}`,
  USER_RESET_PASSWORD: (userId: string) => `/api/v1/users/${userId}/reset-password`,
  ROLES: '/api/v1/roles',
  ROLE_ASSIGNMENTS: '/api/v1/role-assignments',
  ROLE_ASSIGNMENTS_BY_USER: (userId: string) => `/api/v1/role-assignments/user/${userId}`,
  ROLE_ASSIGNMENT_BY_ID: (assignmentId: string) => `/api/v1/role-assignments/${assignmentId}`,
  SOP_FACTORY_ARTIFACTS: '/api/v1/sop-factory/artifacts',
};
